export default __webpack_public_path__ + "static/media/ladies-tour3.a9c3d5e6.jpg";